<div class="modal-header">
  <h5 class="modal-title">Replace unsaved comment?</h5>
  <span class="cursor-pointer" (click)="modal.dismiss()">
    <i class="fa fa-close" ngbTooltip="Close"></i>
  </span>
</div>
<div class="modal-body">
  <p>
    You have unsaved comment text. Do you want to replace it with the new
    selection?
  </p>
</div>
<div class="modal-footer">
  <button
    type="button"
    class="btn btn-sm btn-secondary"
    (click)="modal.dismiss()">
    Keep current
  </button>
  <button
    type="button"
    class="btn btn-sm btn-primary"
    (click)="modal.close('replace')">
    Replace
  </button>
</div>
